import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class Requirement extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            solutionId: props.SolutionId,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/solution/requirement/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        if (this.isBlank(this.state.data.record.firstPrice)) this.state.data.record.firstPrice = 0;
        if (this.isBlank(this.state.data.record.itemCount)) this.state.data.record.itemCount = 0;

        this.httpPost("api/v1/solution/requirement/save", {
            id: this.state.id,
            unitId: this.state.data.record.unitId,
            description: this.state.data.record.description,            
            firstPrice: parseInt(this.state.data.record.firstPrice),
            itemCount: parseInt(this.state.data.record.itemCount),
            itemName: this.state.data.record.itemName,
            solutionId: this.state.solutionId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "90%" }}>
                    <div className="modal-content">
                        <div className="modal-body" style={{ "padding": "0" }}>
                            <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title">
                                    {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات نیازمندی" : "افزودن نیازمندی جدید"}
                                </h4>
                            </div>
                            <div className="modal-body">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="form-group">
                                                <label for="name" className="title1">عنوان نیازمندی</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.itemName} onChange={e => this.state.data.record.itemName = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                    </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="name" className="title1">تعداد</label>
                                            <input defaultValue={this.state.data.record.itemCount} onChange={e => this.state.data.record.itemCount = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                        </div>
                                    </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">واحد</label>
                                            <SelectAsync
                                                defaultValue={this.state.data.record.unitId != this.defaultGuid() ? [{ value: this.state.data.record.unitId, label: this.state.data.record.unitName }] : null}
                                                isMulti={false}
                                                placeholder="واحد اندازه گیری"
                                                defaultOptions
                                                loadOptions={this.loadUnitsOptions}
                                                onChange={e => this.state.data.record.unitId = e.value}
                                            />
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="form-group">
                                            <label for="name" className="title1">برآورد اولیه</label>
                                            <input defaultValue={this.state.data.record.firstPrice} onChange={e => this.state.data.record.firstPrice = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                        </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">توضیحات</label>
                                            <input defaultValue={this.state.data.record.description} onChange={e => this.state.data.record.description = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                                <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                    ذخیره
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}